var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"loader-component",class:_vm.classes},[_c('div',{staticClass:"loader-component__loader",class:_vm.classes})])
}
var staticRenderFns = []

export { render, staticRenderFns }